module.exports = __webpack_public_path__ + "441a2e446d3be6fe793fcda1e3cefc83.svg";